import { AskRequest, AskResponse, ChatRequest } from "./models";
import {getAccessTokenFromStorage, getTenantNameFromStorage} from "../helpers/accessTokenHelpers";

export async function askApi(options: AskRequest): Promise<AskResponse> {
    const response = await fetch("/ask", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getAccessTokenFromStorage()}`
        },
        body: JSON.stringify({
            question: options.question,
            approach: options.approach,
            overrides: {
                retrieval_mode: options.overrides?.retrievalMode,
                semantic_ranker: options.overrides?.semanticRanker,
                semantic_captions: options.overrides?.semanticCaptions,
                top: options.overrides?.top,
                temperature: options.overrides?.temperature,
                prompt_template: options.overrides?.promptTemplate,
                prompt_template_prefix: options.overrides?.promptTemplatePrefix,
                prompt_template_suffix: options.overrides?.promptTemplateSuffix,
                exclude_category: options.overrides?.excludeCategory
            }
        })
    });

    const parsedResponse: AskResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}


export async function getContentMetadata(id: string): Promise<any> {
    const response = await fetch(`/reference/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getAccessTokenFromStorage()}`
        }
    });

    const parsedResponse: any = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}

export async function getSeismicSearchData(id: string): Promise<any> {
    const response = await fetch(`/es_reference/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getAccessTokenFromStorage()}`
        }
    });

    const parsedResponse: any = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}

export async function chatApiStream(question: string, lastQuery:any, lastAnswer:any): Promise<any> {

    //requests.request("GET", f"https://service-discovery.seismic.com/api/sds/v1/tenants/{tenantId}/services").json() in fetch js
    const sdsResponse = await fetch('https://service-discovery.seismic.com/api/sds/v1/tenants/' + getTenantNameFromStorage() + '/services', {
        method: 'GET',
        headers: {
            "Authorization": `Bearer ${getAccessTokenFromStorage()}`,
            "Content-Type": "application/json"
        }
    });

    //get json
    const sdsJson = await sdsResponse.json();

    let uri = undefined

    try {
        uri = sdsJson['serviceAddress']['content-discovery-ai']
    } catch (e) {
        //console.log(e)
    }

    //console.log(sdsResponse)

    let obj:any = {
        "query": question
    };

    if(lastQuery && lastQuery != "") {
        obj['history'] = [{
            "query": lastQuery,
            "answer": lastAnswer
        }]
    }

    const response = await fetch(uri + '/api/snippets/models/Snippets', {
        method: 'POST',
        headers: {
            "Authorization": `Bearer ${getAccessTokenFromStorage()}`,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(obj)
    });

    if (response.ok) {
        return await response.json();
    } else {
        throw new Error(`Request failed with status: ${response.status}`);
    }

    /*return {
        "data": {
            "answer": "Live docs technology enables users to create personalized presentations by integrating data from various sources. It offers front-end customization and internal collaboration, reducing manual updates and providing control over changes. Live docs also provide insights into customer engagement, allowing users to tailor follow-up communications. Additionally, users can create dedicated digital sales rooms, send personalized emails, and leverage analytics to understand customer preferences. By automating content creation and management, live docs aim to empower sellers, reduce content sprawl, and improve overall efficiency.",
            "detail": "Summary generated.",
            "input_classification": "verified_keyword",
            "model": "Snippets",
            "query": "live docs",
            "response_type": "summary",
            "sources": [
                {
                    "content_source": "DocCenter",
                    "id": "177328e2-e72f-4d16-b080-a186b7a37b1a",
                    "title": "Pete Demo - Demo walk through & discover tips.",
                    "url": "https://quake.seismic.com/app/#/content/177328e2-e72f-4d16-b080-a186b7a37b1a"
                },
                {
                    "content_source": "DocCenter",
                    "id": "87b4184c-b0a7-40cf-b943-69fc943357ac",
                    "title": "Nov 2023 Technical Enablement Demo: Custom Content",
                    "url": "https://quake.seismic.com/app/#/content/87b4184c-b0a7-40cf-b943-69fc943357ac"
                },
                {
                    "content_source": "DocCenter",
                    "id": "de24dfe3-78bb-4410-b2df-b984d984dd10",
                    "title": "SEC Demo - Aly Smith",
                    "url": "https://quake.seismic.com/app/#/content/de24dfe3-78bb-4410-b2df-b984d984dd10"
                },
                {
                    "content_source": "DocCenter",
                    "id": "a53b5b01-abd3-4f97-82e2-468f52199894",
                    "title": "Recording of Content Automation Journey Conversation",
                    "url": "https://quake.seismic.com/app/#/content/a53b5b01-abd3-4f97-82e2-468f52199894"
                },
                {
                    "content_source": "DocCenter",
                    "id": "c549e45e-a00f-498f-886e-4e6c1a6df327",
                    "title": "LiveDocs for LDX",
                    "url": "https://quake.seismic.com/app/#/content/c549e45e-a00f-498f-886e-4e6c1a6df327"
                }
            ],
            "uid": "5e5e3435-0f09-4cee-a13f-e5b5bf3ea499"
        },
        "debug": {
            "question_type_detection": 0.0,
            "retrieval": {
                "final_object_building": 0.0,
                "get_knowledge_permissions": 0.74,
                "get_seismic_permissions": 0.2,
                "load_v2_vars": 0.0,
                "query_building": 0.0,
                "search_execution": 0.23,
                "start": 0.0,
                "total": 1.17
            },
            "summary_generation": 2.55,
            "total": 3.73
        },
        "model_name": "snippets"
    }*/

}

export async function chatApi(options: ChatRequest): Promise<AskResponse> {
    const response = await fetch("/chat", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getAccessTokenFromStorage()}`
        },
        body: JSON.stringify({
            history: options.history,
            approach: options.approach,
            overrides: {
                retrieval_mode: options.overrides?.retrievalMode,
                semantic_ranker: options.overrides?.semanticRanker,
                semantic_captions: options.overrides?.semanticCaptions,
                top: options.overrides?.top,
                temperature: options.overrides?.temperature,
                prompt_template: options.overrides?.promptTemplate,
                prompt_template_prefix: options.overrides?.promptTemplatePrefix,
                prompt_template_suffix: options.overrides?.promptTemplateSuffix,
                exclude_category: options.overrides?.excludeCategory,
                suggest_followup_questions: options.overrides?.suggestFollowupQuestions
            }
        })
    });

    const parsedResponse: AskResponse = await response.json();
    if (response.status > 299 || !response.ok) {
        throw Error(parsedResponse.error || "Unknown error");
    }

    return parsedResponse;
}

export function getCitationFilePath(citation: string): string {
    return `/content/${citation}`;
}
